const CustomerApprovalModal = ({
  show,
  modalData,
  showSmsOption,
  selectedMethod,
  setSelectedMethod,
  onOk,
  onCancel,
  t,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded shadow-lg">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">{t("customer_approval")}</h5>
          </div>
          <div className="modal-body">
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="approvalMethod"
                id="useEmail"
                value="email"
                checked={selectedMethod === "email"}
                onChange={(e) => setSelectedMethod(e.target.value)}
              />
              <label className="form-check-label" htmlFor="useEmail">
                {t("use_email")}: <strong>{modalData?.email}</strong>
              </label>
            </div>
            {showSmsOption && (
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="approvalMethod"
                  id="useSMS"
                  value="sms"
                  checked={selectedMethod === "sms"}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                />
                <label className="form-check-label" htmlFor="useSMS">
                  {t("use_sms")}: <strong>{modalData?.phoneNumber}</strong>
                </label>
              </div>
            )}
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="approvalMethod"
                id="selfSigned"
                value="self"
                checked={selectedMethod === "self"}
                onChange={(e) => setSelectedMethod(e.target.value)}
              />
              <label className="form-check-label" htmlFor="selfSigned">
                {t("self_signed")}
              </label>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0 d-flex justify-content-end gap-2">
            <button
              className="btn btn-success m-0"
              disabled={!selectedMethod}
              onClick={onOk}
            >
              {t("ok")}
            </button>
            <button className="btn btn-cancel m-0" onClick={onCancel}>
              {t("cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerApprovalModal;
